export const LocalStorageKeys = {
  useCache: "useCache",
  threadsTimeFrom: "threadsTimeFrom",
};
